import { Section } from '../Section/Section';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
export function PanelSection(props) {
  const {
    domProps,
    tokenProps
  } = filterProps(props);
  return /*#__PURE__*/_jsx(Section, Object.assign({
    paddingInline: "1000",
    "data-panel-section": ""
  }, props, domProps, tokenProps));
}